












import Vue from "vue";

// Import Components
import HeaderSection from "../modules/header/HeaderSection.vue";

export default Vue.extend({
  name: "LayoutSection",
  props: {
    headline: {
      type: String,
      required: false,
    },
  },
  components: {
    HeaderSection,
  },
});
